import React from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import {
  FillTheFieldErrorMessage,
  FormInput,
  FormTextArea,
  FormYearDatePicker,
} from "@/shared/Components";
import type { FieldProps } from "@/pages/ContactsPage/types";
import styles from "./styles.module.scss";

export const Education: React.FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`educations.${index}`} />
      <FormInput
        name={`educations.${index}.place`}
        placeholder={t("contactsPage.activities.school")}
      />
      <FormInput
        name={`educations.${index}.major`}
        placeholder={t("contactsPage.activities.major")}
      />
      <div className={styles.dates}>
        <FormYearDatePicker
          placeholder={t("common.dateFrom")}
          name={`educations.${index}.educationStart`}
        />
        <FormYearDatePicker
          placeholder={t("common.dateTo")}
          name={`educations.${index}.educationEnd`}
        />
      </div>
      <FormTextArea name={`educations.${index}.additional`} placeholder={t("common.about")} />
    </FieldLayout>
  );
};
